module.exports = __webpack_public_path__ + "5f461efb87f37c825afb9c1ff6148291.svg";